(() => {
  if (window.__sampleStopVaultTrackingInstalled) return;
  window.__sampleStopVaultTrackingInstalled = true;

  const downloadSelector = "a[data-vault-download], a[href*='dropbox.com']";
  const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  window.addEventListener("click", async (event) => {
    const eventPath = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
    const pathLink = eventPath.find((candidate) => candidate?.matches?.(downloadSelector));
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = pathLink || target?.closest?.(downloadSelector);
    if (!link) return;

    // Catch the click before page-builder or Dropbox navigation can end the page.
    event.preventDefault();
    if (link.dataset.vaultTrackingInFlight === "true") return;
    link.dataset.vaultTrackingInFlight = "true";

    const explicitContainer = link.closest("[data-vault-product-id], [data-vault-product-name]");
    const read = (name) => link.dataset[name] || explicitContainer?.dataset?.[name] || "";
    let node = link.parentElement;
    let relatedProductLink = null;
    let relatedHeading = null;
    while (node && node !== document.body) {
      relatedProductLink ||= [...node.querySelectorAll("a[href]")].find((candidate) => {
        if (candidate === link) return false;
        try { return new URL(candidate.href, window.location.href).pathname.includes("/products/"); }
        catch { return false; }
      }) || null;
      relatedHeading ||= node.querySelector("h1, h2, h3, h4, h5, h6, [data-product-name]");
      if (relatedProductLink && relatedHeading) break;
      node = node.parentElement;
    }
    const productId = String(read("vaultProductId")).replace(/^gid:\/\/shopify\/Product\//i, "").trim();
    const productName = read("vaultProductName").trim() || relatedHeading?.textContent?.trim() || "";
    const productUrl = read("vaultProductUrl").trim() || relatedProductLink?.href || "";
    const sampleName = read("vaultSampleName").trim() || (productName ? `${productName} free preview` : link.textContent.trim());

    const properties = {
      ProductID: productId || undefined,
      ProductName: productName || sampleName || "Vault sample",
      "Related Product Name": productName || undefined,
      ProductURL: productUrl || undefined,
      Category: read("vaultCategory").trim() || undefined,
      SampleName: sampleName || undefined,
      DownloadURL: link.href,
      PageURL: window.location.href,
      TrackerVersion: "vault-click-v4"
    };

    const destination = link.href;
    let navigationReleased = false;
    const releaseNavigation = () => {
      if (navigationReleased) return;
      navigationReleased = true;
      window.location.assign(destination);
    };
    window.setTimeout(releaseNavigation, 3500);

    try {
      // Do not wait forever for the modern Klaviyo promise. Some privacy/browser
      // contexts leave it pending even though the legacy onsite queue can send.
      const readyUntil = Date.now() + 1500;
      while (typeof window.klaviyo?.track !== "function" && Date.now() < readyUntil) {
        await delay(50);
      }
      let delivered = false;
        if (window.klaviyo && typeof window.klaviyo.track === "function") {
        delivered = await Promise.race([
            Promise.resolve(window.klaviyo.track("Vault Sample Downloaded", properties))
              .then((result) => result !== false)
              .catch(() => false),
            delay(900).then(() => false)
          ]);
      }

        if (!delivered) {
        window._learnq = window._learnq || [];
        window._learnq.push(["track", "Vault Sample Downloaded", properties]);
        await delay(900);
      }
    } catch (error) {
      console.warn("Vault Sample Downloaded tracking failed", error);
    } finally {
      releaseNavigation();
    }
  }, { capture: true });
})();